import axios from "axios";
import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getData } from "./api/method";

const checkTokenUser = async () => {
  const token = localStorage.getItem("token_key") || "";
  const username = localStorage.getItem("username") || "";

  try {
    const result = await getData(`/api/User/${username}`)
     axios({
      method: `Get`,
      url: `${process.env.REACT_APP_URL_API}/api/User/${username}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (err) {
    console.log("err get");
  }
};

export default function CheckAdmin() {
  const [dataUser, setDataUser] = useState("");

  useEffect(() => {
    async function checkData() {
      const tokenUser = await checkTokenUser();
      setDataUser(tokenUser.data.admin);
    }

    checkData();
  }, []);

  if (dataUser === 1) {
    // console.log(dataUser);
    return <Outlet />;
  } else if (dataUser === 0) {
    // console.log(dataUser);
    return <Navigate to="/" />;
  }
}
